import {useEffect, useState, useRef, createContext, useContext} from 'react';
import {dateToCalendar, showToast, updateUTCDate, commonLogDate, strArraySortAsc} from '../common/app_common.js';
import {Title, LoadingSpinner, CommonDatePicker} from '../common/component_common.js';
import '.././common/css/analytics.css';
import {AnalyticChart} from './analytics/chart.js';
import {BsDashSquare} from 'react-icons/bs';
import {getApiSitesSummary} from '../common/fetch_api/site.js';
import Highcharts from 'highcharts/highstock';
import HighchartsReact from 'highcharts-react-official';
import {utils as xlsxUtils, writeFile as xlsxWriteFile } from 'xlsx'
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

const analyticsContext = createContext();
const edgeContext = createContext();
const lineColor = ['#40DFFF','#F9C3FA','#B080FF','#00FF0E'];

const edgeObject = {
    key: '',
    site: '',
    edge: '',
    name: ''
}

const analyticsObject = {
    key: '',
    category: '0',
    gathering: 'sampling',
    dateFrom: '',
    dateTo: '',
    edges:
    [
    ]
}

const categoryList = ['DigiCaster CPU Usage', 'DigiCaster MEM Usage', 'DigiCaster DISK Usage', 'DigiCaster Output Bitrate', 'DigiCaster FEC Bitrate', 'RM STL Bitrate', 'RM FEC Bitrate', 'RM FEC Overhead Percent', 'RM RSSI', 'RM MER', 'RM Network Delay', 'RM MND'];
const categoryQuery = ['dcs_system_usage_percent{type="cpu", id=""}', 'dcs_system_usage_percent{type="mem", id=""}', 'dcs_system_usage_percent{type="disk", id=""}', 'dcs_out_bytes{id=""}', 'dcs_fec_bytes{id=""}', 'atsc3_stl_bytes{id=""}', 'atsc3_stl_fec_bytes{id=""}', 'atsc3_fec_overhead_percent{id=""}', 'atsc3_tuner_rssi_dbm{id=""}', 'atsc3_tuner_mer_db{id=""}', 'atsc3_network_delay_ms{id=""}', 'atsc3_mnd_ms{id=""}'];

const EdgeComp = ({analyticsKey, sessionData, edgeKey, siteInfo, isCreate}) => {

    const {createEdgeData, saveEdgeData} = useContext(analyticsContext);
    const {onClickRemoveEdge, category, analyticsResult} = useContext(edgeContext);
    
    const [siteCur, setSiteCur] = useState('');
    const [siteList, setSiteList] = useState(null);
    
    const [edgeCur, setEdgeCur] = useState(JSON.stringify({id:'', name:''}));
    const [edgeList, setEdgeList] = useState(null);
    
    const [maxValue, setMaxValue] = useState(['--/--/-- --:--:--', '-']);
    const [minValue, setMinValue] = useState(['--/--/-- --:--:--', '-']);
    const [avrValue, setAvrValue] = useState('-');
    const [dataCount, setDataCount] = useState('-');

    const onChangeSite = (e) => {
        let value = e.target.value;
        setSiteCur(value);
        saveEdgeData(analyticsKey, edgeKey, 'site', value);
    }

    const onChangeEdge = (e) => {
        let value = JSON.parse(e.target.value);
        setEdgeCur(e.target.value);
        saveEdgeData(analyticsKey, edgeKey, 'edge', value.id, value.name);
    }

    function getErrorEdge()
    {
        const edgeId = JSON.parse(edgeCur).id;
        
        //다른 edge와 비교해 같은 edge가 있을때도 처리
        if(edgeId === '')
        {
            return 'error-line';
        }
        
        if( sessionStorage.getItem('ssAnalyticInfo') )
        {
            const getSession = JSON.parse(sessionStorage.getItem('ssAnalyticInfo'));
            let findIndex = getSession.findIndex(analytics => analytics.key === analyticsKey);
            
            if( findIndex < 0 )
            {
                return 'error-line';
            }
            
            const analyticsData = getSession[findIndex];
            const count = analyticsData.edges.filter( (edge) => {return edge.edge === edgeId }).length;

            if( count > 1 )
            {
                return 'error-line';
            }
        }

        return '';
    }

    function getLineColor()
    {
        const idx = parseInt(edgeKey.at(-1));
        return lineColor[idx];
    }

    const isMounted = useRef(false);
    const isUpdateSite = useRef(false);
    const isUpdateEdge = useRef(false);
    useEffect( () => {
        if(!isMounted.current)
        {
            isMounted.current = true;
            return;
        }
        
        let exist = true;
        let existSite = siteInfo.filter( site => site.name === siteCur )[0];
        
        if( !existSite || existSite.edgeList.length < 1 )
        {
            exist = false;
        }
        else
        {
            let type = 's-agent';
            if( parseInt(category) > 4 )
            {
                type = 'rm';
            }
            let edgeTemp = existSite.edgeList.filter( edge => edge.type === type );
            const existEdge = edgeTemp.sort((a, b) => strArraySortAsc(a.name, b.name));

            if( !existEdge || existEdge.length < 1 )
            {
                exist = false;
            }
            else
            {
                setEdgeList( existEdge.map( (edge) => (
                    <option key={edge.id} value={JSON.stringify({id: edge.id, name: edge.name})}>{edge.name}</option>
                )));

                if( !isUpdateEdge.current && !isCreate)
                {
                    setEdgeCur(JSON.stringify({id: sessionData.edge, name: sessionData.name}));
                }
                else
                {
                    setEdgeCur(JSON.stringify({id: existEdge[0].id, name: existEdge[0].name}));
                    createEdgeData(analyticsKey, edgeKey, siteCur, existEdge[0].id, existEdge[0].name);
                }

                isUpdateEdge.current = true;
            }
        }

        if( !exist )
        {
            setEdgeList( <option value=''>No Edge</option> );
            setEdgeCur(JSON.stringify({id: '', name: ''}));
            createEdgeData(analyticsKey, edgeKey, siteCur, '', '');
        }

    }, [siteCur, category]);

    useEffect( () => {
        const edgeName = JSON.parse(edgeCur).name;
        if( analyticsResult.hasOwnProperty(edgeName) )
        {
            setMaxValue([analyticsResult[edgeName].maxTime, analyticsResult[edgeName].maxValue]);
            setMinValue([analyticsResult[edgeName].minTime, analyticsResult[edgeName].minValue]);
            setAvrValue(analyticsResult[edgeName].avr);
            setDataCount(analyticsResult[edgeName].count);
        }
    }, [analyticsResult]);

    useEffect( () => {
        setSiteList( siteInfo.map( (site) => (
            <option key={site.name} value={site.name}>{site.name}</option>
        )));
        
        if( siteInfo.length > 0 )
        {
            if( !isUpdateSite.current && !isCreate)
            {
                setSiteCur(sessionData.site);
            }
            else
            {
                setSiteCur(siteInfo[0].name);
            }

            isUpdateSite.current = true;
        }
        else
        {
            createEdgeData(analyticsKey, edgeKey, '', '');
        }
    }, [siteInfo]);

    return (
        <>
            <hr />
            <div className="device-list-area">
                <div className="d-flex flex-wrap mb-1">
                    <div className="mdCol">
                        <div className="d-flex">
                            <div className="d-flex">
                                <div className="remove-btn" onClick={() => {onClickRemoveEdge(edgeKey)}}><BsDashSquare /></div>
                                <div className="label-a">Site</div>
                            </div>
                            <select className="form-select form-select-sm" value={siteCur} onChange={onChangeSite}>
                                {siteList}
                            </select>
                        </div>
                    </div>
                    <div className="mdCol">
                        <div className="d-flex ms-2">
                            <div className="d-flex">
                                <div className="label-a">Edge</div>
                            </div>
                            <select className={`form-select form-select-sm ${getErrorEdge()}`} value={edgeCur} onChange={onChangeEdge}>
                                {edgeList}
                            </select>
                        </div>
                    </div>
                    <div className="lgCol">
                        <div className="d-flex align-label">
                            <div className="line-color" style={{backgroundColor:getLineColor()}}></div>
                            <div className="label-b">Max Value</div>
                            <div className="label-b">{maxValue[0]}</div>
                            <div className="value-label">{maxValue[1]}</div>
                        </div>
                    </div>
                    <div className="lgCol">
                        <div className="d-flex align-label">
                            <div className="label-b">Min Value</div>
                            <div className="label-b">{minValue[0]}</div>
                            <div className="value-label">{minValue[1]}</div>
                        </div>
                    </div>
                    <div className="smCol">
                        <div className="d-flex align-label">
                            <div className="label-b">Average Value</div>
                            <div className="value-label">{avrValue}</div>
                        </div>
                    </div>
                    <div className="smCol">
                        <div className="d-flex align-label">
                            <div className="label-b">Data Count</div>
                            <div className="value-label">{dataCount}</div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

const AnalyticsComp = ({analyticsKey, sessionData, isCreate}) => {

    const {saveAnalyticsData, onClickRemoveAnalytics, removeEdgeData} = useContext(analyticsContext);
    const [loading, setLoading] = useState(false);

    const isMounted = useRef(false);
    const isUpdate = useRef(false);

    const [edgeCompList, setEdgeCompList] = useState([]);
    const edgeCompIdx = useRef(0);

    const [category, setCategory] = useState('0');
    const [gathering, setGathering] = useState('sampling');
    const [dateFrom, setDateFrom] = useState( () => {
        let now = new Date();
        now.setHours(now.getHours()-1);
        // return dateToCalendar(now);
        return now;
    });
    // const [dateTo, setDateTo] = useState(dateToCalendar(new Date()));
    const [dateTo, setDateTo] = useState(new Date());
    const [siteInfo, setSiteInfo] = useState([]);

    const [analysisCondition, setAnalysisCondition] = useState({
        maxTime: '',
        maxValue: '',
        minTime: '',
        minValue: '',
        avr: '',
        count: ''
    });

    const [analyticsResult, setAnalyticsResult] = useState([{
        maxTime: '',
        maxValue: '',
        minTime: '',
        minValue: '',
        avr: '',
        count: ''
    }]);

    const [chartOptions, setChartOptions] = useState(null);
    const [stockChart, setStockChart] = useState(null);

    const onChangeCategory = (e) => {
        let value = e.target.value;
        setCategory(value);
        saveAnalyticsData(analyticsKey, 'category', value);
    };

    const onChangeGathering = (e) => {
        let value = e.target.value;
        setGathering(value);
        saveAnalyticsData(analyticsKey, 'gathering', value);
    };

    const onChangeDateFrom = (e) => {
        // let value = e.target.value;
        saveAnalyticsData(analyticsKey, 'dateFrom', e);
        setDateFrom(e);
    };

    const onChangeDateTo = (e) => {
        // let value = e.target.value;
        saveAnalyticsData(analyticsKey, 'dateTo', e);
        setDateTo(e);
    };

    const onClickSave = () => {
        
        if( analysisCondition.data.length === 0 )
        {
            showToast('There is no Data', 'warning');
            return;
        }
        
        const filename = commonLogDate() + '_analysis.csv';
        const category = categoryList[analysisCondition.category];
        const dataGathering = analysisCondition.gathering;
        const fromMills = analysisCondition.from * 1000;
        const toMills = analysisCondition.to * 1000;
        const dateFrom = updateUTCDate(new Date(fromMills));
        const dateTo = updateUTCDate(new Date(toMills));

        let edgeInfo = [];
        let edgeDataArr = [];
        let edgeTemp = ['date'];
        for( const item of analysisCondition.edges)
        {
            edgeInfo.push([
                item.site,
                item.name,
                item.edge,
            ]);

            edgeTemp.push(item.name);
        }

        edgeDataArr.push(edgeTemp);
        const dateStep = Math.ceil((toMills - fromMills) / 3600);
        for( let idx = fromMills; idx <= toMills; idx+=dateStep)
        {
            let temp = [];
            temp.push(updateUTCDate(new Date((idx))));
            for( const edgeData of analysisCondition.data )
            {
                let data = edgeData.data.filter( (a) => {return a[0] === idx});
                if(data.length > 0)
                {
                    temp.push(data[0][1]);
                }
            }
            edgeDataArr.push(temp);
        }

        const information = [
            ['Category', category],
            ['DataGathering', dataGathering],
            ['From', dateFrom],
            ['To', dateTo],
            [],
            ['Edge Infomation'],
            ['Site', 'Edge Name', 'ID'],
            ...edgeInfo,
            [],
            ['Data Table'],
            ...edgeDataArr
        ];
        
        const ws = xlsxUtils.json_to_sheet(information);
        ws.A1 = {t: "s"};
        ws.B1 = {t: "s"};
        ws.C1 = {t: "s"};
        const wb = xlsxUtils.book_new();

        xlsxUtils.book_append_sheet(wb, ws, "Data");
        xlsxWriteFile(wb, filename);
    };

    const onClickAddEdge = () => {
        if( edgeCompList.length >= 4 )
        {
            showToast('Up to 4 Edges available!', 'error');
            return;
        }

        let edgeKey = `edgeComp_${edgeCompIdx.current}`;
        setEdgeCompList([...edgeCompList, <EdgeComp key={edgeKey} analyticsKey={analyticsKey} edgeKey={edgeKey} siteInfo={siteInfo} sessionData={null} isCreate={true}/>]);
        edgeCompIdx.current++;
    };

    const onClickRemoveEdge = (edgeKey) => {
        setEdgeCompList(edgeCompList.filter(edge => edge.key !== edgeKey));

        removeEdgeData(analyticsKey, edgeKey);
    }

    const onClickAnalysis = () => {
        
        if( checkError() )
        {
            if( sessionStorage.getItem('ssAnalyticInfo') )
            {
                const getSession = JSON.parse(sessionStorage.getItem('ssAnalyticInfo'));
                let findIndex = getSession.findIndex(analytics => analytics.key === analyticsKey);
                
                if( findIndex < 0 )
                {
                    return;
                }
                
                const analyticsData = getSession[findIndex];
                let size = analyticsData.edges.length;
                if( size > 0 )
                {
                    // Run Analysis
                    setLoading(true);
                    setStockChart(null);
                    AnalyticChart(analyticsData, setChartOptions, setAnalysisCondition, setAnalyticsResult, setLoading);
                }
                else
                {
                    showToast( 'No Device to Analysis', 'error' );
                    return;
                }
            }
        }
    };

    function checkError()
    {
        const frame = document.getElementById(analyticsKey);
        
        if(!frame)
        {
            return false;
        }

        if( frame.querySelector('.error-line') )
        {
            showToast('check Error Parameter', 'error');
            return false;
        }
        
        return true;
    }

    function getErrorDate()
    {
        let wrongDate = false;

        // if( dateFrom === '' || dateTo === '' )
        // {
        //     wrongDate = true;
        // }
        // else
        {
            const term = {all: 7200, sampling: 2592000};
            // const from = new Date(dateFrom);
            // const to = new Date(dateTo);
            const from = dateFrom;
            const to = dateTo;

            const END_LIMIT =  new Date();
            END_LIMIT.setHours(23);
            END_LIMIT.setMinutes(59);
            END_LIMIT.setSeconds(59);
            END_LIMIT.setMilliseconds(999);

            const START_LIMIT = new Date(END_LIMIT.getTime() - (term.sampling * 1000));
            START_LIMIT.setHours(0);
            START_LIMIT.setMinutes(0);
            START_LIMIT.setSeconds(0);
            START_LIMIT.setMilliseconds(0);
            // dateFrom.setAttribute('min', dateToCalendar(START_LIMIT));
            // dateTo.setAttribute('min', dateToCalendar(START_LIMIT));

            const gap = ((to.getTime() - from.getTime()) / 1000) - 1;

            if( from.getTime() > to.getTime() )
            {
                wrongDate = true;
            }

            if( from.getTime() < START_LIMIT.getTime() || to.getTime() < START_LIMIT.getTime() )
            {
                wrongDate = true;
            }
            else if( from.getTime() > END_LIMIT.getTime() || to.getTime() > END_LIMIT.getTime() )
            {
                wrongDate = true;
            }

            if( gathering === 'sampling' )
            {
                //Sampling
                //최대 30일 텀
                if( gap >= term.sampling )
                {
                    wrongDate = true;
                }
            }
            else
            {
                //최대 2시간 텀
                if( gap >= term.all )
                {
                    wrongDate = true;
                }
            }
        }

        if(wrongDate)
        {
            return 'error-line';
        }

        return '';
    }

    useEffect( () => {

        Promise.resolve( getApiSitesSummary() )
        .then( data => {
            if (!Array.isArray(data)) return;
            isMounted.current = true;
            const siteInfo = data.sort((a, b) => strArraySortAsc(a.name, b.name));
            setSiteInfo(siteInfo);
        });
        
    }, []);

    useEffect( () => {

        if( isMounted.current )
        {
            if( !isCreate && !isUpdate.current )
            {
                setCategory(sessionData.category);
                setGathering(sessionData.gathering);
                setDateFrom(new Date(sessionData.dateFrom));
                setDateTo(new Date(sessionData.dateTo));

                let preEdges = [];
                for( const edge of sessionData.edges )
                {
                    preEdges.push(<EdgeComp key={edge.key} analyticsKey={analyticsKey} edgeKey={edge.key} siteInfo={siteInfo} sessionData={edge} isCreate={false}/>);
                    edgeCompIdx.current = parseInt( edge.key.slice('edgeComp_'.length) )+1;
                }
                setEdgeCompList(preEdges);
            }
            else
            {
                saveAnalyticsData(analyticsKey, 'dateFrom', dateFrom);
                saveAnalyticsData(analyticsKey, 'dateTo', dateTo);
                onClickAddEdge();
            }

            isUpdate.current = true;
        }
    }, [siteInfo]);

    useEffect( () => {
        if( !chartOptions ) return;
        
        setStockChart(
            <HighchartsReact highcharts={Highcharts} constructorType={"stockChart"} options={chartOptions} containerProps={{ style: { height: 360 } }} />
        );
    }, [chartOptions])

    return (
        <div id={analyticsKey} className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
            <div className="section analytics">
                <div className="d-flex flex-wrap">
                    <div className="col-xxl-2 col-xl-2 col-lg-6 col-md-6 col-sm-12 col-12 mt-2">
                        <div className="d-flex">
                            <div className="d-flex">
                                <div className="remove-btn" onClick={() => {onClickRemoveAnalytics(analyticsKey)}}><BsDashSquare /></div>
                                <div className="label-a">Category</div>
                            </div>
                            <select className="form-select form-select-sm" value={category} onChange={onChangeCategory}>
                                {
                                    categoryList.map( (name, idx) =>
                                        <option key={name} value={idx}>{name}</option>
                                    )
                                }
                            </select>
                        </div>
                    </div>
                    <div className="col-xxl-2 col-xl-2 col-lg-6 col-md-6 col-sm-12 col-12 mt-2">
                        <div className="d-flex ms-2">
                            <div className="d-flex">
                                <div className="label-a">DataGathering</div>
                            </div>
                            <select className="form-select form-select-sm" value={gathering} onChange={onChangeGathering}>
                                <option value="sampling">Sampling</option>
                                <option value="all">All</option>
                            </select>
                        </div>
                    </div>
                    <div className="col-xxl-4 col-xl-4 col-lg-6 col-md-6 col-sm-12 col-12 mt-2">
                        <div className="d-flex ms-2">
                            <div className="d-flex">
                                <div className="label-a">Date</div>
                            </div>
                            <CommonDatePicker domId={null} domClass={`form-control input-box date-picker text-center ${getErrorDate()}`} state={dateFrom} setState={onChangeDateFrom} domDisable={false}/>
                            {/* <input className={`form-control input-box dateFrom ${getErrorDate()}`} type="datetime-local" value={dateFrom} onChange={onChangeDateFrom}></input> */}
                            <span className="label-a dash">~</span>
                            <CommonDatePicker domId={null} domClass={`form-control input-box date-picker text-center ${getErrorDate()}`} state={dateTo} setState={onChangeDateTo} domDisable={false}/>
                            {/* <input className={`form-control input-box dateTo ${getErrorDate()}`} type="datetime-local" value={dateTo} onChange={onChangeDateTo}></input> */}
                        </div>
                    </div>
                    <div className="col-xxl-4 col-xl-4 col-lg-6 col-md-6 col-sm-12 col-12 mt-2">
                        <div className="d-flex justify-content-between">
                            <div className="d-flex">
                                <button type="button" className="btn btn-secondary btn-sm ms-2" onClick={onClickSave}>Save</button>
                            </div>
                            <div className="d-flex justify-content-end analysis-btn-area">
                                <div className="btn btn-success btn-sm" onClick={onClickAddEdge}>Add Edge</div>
                                <div className="btn btn-primary btn-sm ms-2" onClick={onClickAnalysis}>Analysis</div>
                            </div>
                        </div>
                    </div>
                </div>
                <edgeContext.Provider value={{category, onClickRemoveEdge, analyticsResult}}>
                    {edgeCompList}
                </edgeContext.Provider>
                <hr />
                <div className="chart-area">
                    {stockChart}
                </div>
            </div>
            <LoadingSpinner loading={loading}/>
        </div>
    )
}

const PageAnalytics = () => {

    const [sessionData, setSessionData] = useState([]);

    const [analyticsCompList, setAnalyticsCompList] = useState([]);
    const analyticsCompIdx = useRef(0);

    const onClickAddAnalytics = () => {
        let analyticsKey = `analyticsComp_${analyticsCompIdx.current}`;
        setAnalyticsCompList([...analyticsCompList, <AnalyticsComp key={analyticsKey} analyticsKey={analyticsKey} isCreate={true}/>]);
        
        let preState = sessionData;
        let newObject = JSON.parse(JSON.stringify(analyticsObject));
        newObject.key = analyticsKey;
        preState.push(newObject);
        setSessionData(preState);

        analyticsCompIdx.current++;
    }

    const onClickRemoveAnalytics = (analyticsKey) => {
        setAnalyticsCompList(analyticsCompList.filter(analytics => analytics.key !== analyticsKey));
        
        let analytics = [...sessionData.filter(analytics => analytics.key !== analyticsKey)];
        setSessionData(analytics);
        sessionStorage.setItem('ssAnalyticInfo', JSON.stringify(analytics));
    }

    const saveAnalyticsData = (key, attr, value) => {
        
        let findIndex = sessionData.findIndex(analytics => analytics.key === key);

        if( findIndex < 0 )
        {
            return;
        }

        let analytics = [...sessionData];
        analytics[findIndex][attr] = value;
        setSessionData(analytics);
        sessionStorage.setItem('ssAnalyticInfo', JSON.stringify(analytics));
    }

    const createEdgeData = (akey, eKey, site, edge, name) => {
        
        let findIndexA = sessionData.findIndex(analytics => analytics.key === akey);
        let findIndexE = sessionData[findIndexA].edges.findIndex(edge => edge.key === eKey);
        let analytics = [...sessionData];

        if( findIndexE > -1 )
        {
            saveEdgeData(akey, eKey, 'edge', edge, name);
            return;
        }

        analytics[findIndexA].edges.key = eKey;
        analytics[findIndexA].edges.site = site;
        analytics[findIndexA].edges.edge = edge;
        analytics[findIndexA].edges.name = name;
        
        let preState = analytics[findIndexA].edges;
        let lastIdx = preState.length;
        let newObject = JSON.parse(JSON.stringify(edgeObject));
        newObject.key = eKey;
        newObject.site = site;
        newObject.edge = edge;
        newObject.name = name;
        preState[lastIdx] = newObject;

        setSessionData(analytics);
        sessionStorage.setItem('ssAnalyticInfo', JSON.stringify(analytics));
    }

    const saveEdgeData = (akey, eKey, type, value, name='') => {
        
        let findIndexA = sessionData.findIndex(analytics => analytics.key === akey);
        let findIndexE = sessionData[findIndexA].edges.findIndex(edge => edge.key === eKey);

        if( findIndexA < 0 || findIndexE < 0 )
        {
            return;
        }

        let analytics = [...sessionData];
        analytics[findIndexA].edges[findIndexE][type] = value;

        if( type === 'edge' )
        {
            analytics[findIndexA].edges[findIndexE].name = name;
        }
        
        setSessionData(analytics);
        sessionStorage.setItem('ssAnalyticInfo', JSON.stringify(analytics));
    }

    const removeEdgeData = (akey, eKey) => {
        
        let findIndexA = sessionData.findIndex(analytics => analytics.key === akey);

        if( findIndexA < 0 )
        {
            return;
        }

        let analytics = [...sessionData];
        analytics[findIndexA].edges = [...analytics[findIndexA].edges.filter(edge => edge.key !== eKey)];
        
        setSessionData(analytics);
        sessionStorage.setItem('ssAnalyticInfo', JSON.stringify(analytics));
    }

    useEffect( () => {
        //세션에서 이전 사용된 설정값을 읽어와 그려줘야함
        if( sessionStorage.getItem('ssAnalyticInfo') )
        {
            const getData = JSON.parse(sessionStorage.getItem('ssAnalyticInfo'));
            setSessionData(getData);

            let preAnalytics = [];
            for( const data of getData )
            {
                preAnalytics.push(<AnalyticsComp key={data.key} analyticsKey={data.key} sessionData={data} isCreate={false}/>);
                analyticsCompIdx.current = parseInt( data.key.slice('analyticsComp_'.length) )+1;
            }
            setAnalyticsCompList(preAnalytics);
            // setAnalyticsCompList(JSON.parse(sessionStorage.getItem('ssAnalyticInfo')));
        }
    }, []);

    return (
        <>
            <Title title='Analytics'></Title>
            <div className="d-flex flex-column mt-2">
                <div className="analytics-list">
                    <analyticsContext.Provider value={{saveAnalyticsData, createEdgeData, saveEdgeData, onClickRemoveAnalytics, removeEdgeData}}>
                        {analyticsCompList}
                    </analyticsContext.Provider>
                </div>
                <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 mt-2 pe-2">
                    <button type="button" className="btn btn-primary add-analytics-btn" onClick={onClickAddAnalytics}>+ Add Analytics</button>
                </div>
            </div>
        </>
    )
}

export default PageAnalytics;